<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in recourceDetail.langData"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t('message.name')}} - {{langLabel(langItem.langCode)}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.name"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Name - '+langLabel(langItem.langCode)"
                    />
                  </div>
                  <label class="error">{{ errors.first('Name - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Category") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <select class="form-control"  :name="'Category'+langLabel(langItem.langCode)" v-validate="'required'" v-model="recourceDetail.resourceGroupId">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option  class="ng-binding" v-for="category in categoryList" v-bind:value="category.id">{{category['name'+langItem.langCode]}}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('Category'+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  description - {{langLabel(langItem.langCode)}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.description"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'description - '+langLabel(langItem.langCode)"
                      style="min-height:100px;"
                      maxLength="200"
                    />
                  </div>
                  <label class="error">{{ errors.first('description - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  URL - {{langLabel(langItem.langCode)}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.url"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'url - '+langLabel(langItem.langCode)"
                    />
                  </div>
                  <label class="error">{{ errors.first('url - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Interviewee icon - {{langLabel(langItem.lang)}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <file-upload
                    :fileUploadUrl="fileUploadUrl"
                    :filewidth="300"
                    :fileheight="300"
                    :limit="5"
                    v-model="langItem.logo"
                    :name="'logo - '+langLabel(langItem.langCode)"
                    @click="validateIt('logo - '+langLabel(langItem.langCode))"
                    v-validate="'required'"
                  >
                    <template v-slot:sizeError>
                      <div style="color:red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color:red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>300 x 300, Max 5 MB.</template>
                  </file-upload>
                  <label
                    class="error"
                  >{{ errors.first('logo - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div v-if="$route.query.id" class="btn btn-primary" @click="Delete()">{{$t("message.Delete") }}</div>
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import fileupload from "../components/common/fileupload";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      categoryId:"",
      recourceDetail:{
        resourceGroupId:''
      },
      categoryList:[]
    };
  },
  components: {
    "file-upload": fileupload
  },
  created() {
    let langData = [];
    this.langKey.forEach(element => {
      langData.push({ langCode: element });
    });
    this.recourceDetail.langData = langData;
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.id = id;
        let data = await this.$store.dispatch("getResourceDetail", this.setFormData(obj));
        var langData = [];
        this.langKey.forEach(element => {
          for(var i=0;i<data.data.result.langData.length;i++){
            if(data.data.result.langData[i].langCode==element){
              langData.push(data.data.result.langData[i])
            }
          }
        });
        data.data.result.langData = langData;
        this.$set(this, "recourceDetail", data.data.result);
      } else {
      }
      this.getResourceGroupList();
    },
    async getResourceGroupList(){
        let obj = this.getAuthObj;
        obj.sortField = 'id';
        obj.sortType = "ASC";
        obj.startRow = 0;
        obj.maxRows = 10000;
        let data = await this.$store.dispatch("getResourceGroupList", this.setFormData(obj));
        for(var i=0;i<data.data.resultList.length;i++){
          for(var j=0;j<data.data.resultList[i].langData.length;j++){
            if(data.data.resultList[i].langData[j].langCode=="en_US"){
              data.data.resultList[i]['name'+'en_US'] = data.data.resultList[i].langData[j].name;
            }
            if(data.data.resultList[i].langData[j].langCode=="zh_HK"){
              data.data.resultList[i]['name'+'zh_HK'] = data.data.resultList[i].langData[j].name;
            }
            if(data.data.resultList[i].langData[j].langCode=="zh_CN"){
              data.data.resultList[i]['name'+'zh_CN'] = data.data.resultList[i].langData[j].name;
            }
          }
        }
        this.$set(this, "categoryList", data.data.resultList);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for(var key in this.recourceDetail){
          obj[key] = this.recourceDetail[key];
        }
        obj.langData = JSON.stringify(obj.langData);
        if(this.$route.query.id){
           var  data = await this.$store.dispatch("updateResource", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createResource", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.ids = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteResource", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  }
};
</script>
